import { useMemo } from "react";
import styles from "./orderView.module.css";

const deliveryTypes = {
  1: "Самовывоз",
  2: "Курьер",
  3: "СДЭК",
  4: "Почта России",
};

export default function OrderView({ order, onOpenOrder }) {

  const date = useMemo(() => {
    return new Date(order.dateCreated).toLocaleDateString("ru-RU", {
      day: "numeric",
      month: "long",
      year: "2-digit",
    });
  }, [order.dateCreated]);


  return <article
        className={styles.order}
        draggable
        onDragStart={() =>
          sessionStorage.setItem(
            "moveOrderBoard",
            JSON.stringify({
              orderId: order.id,
              columnId: order.columnId,
            })
          )
        }
      >
        <button
          type="button"
          className={styles.openButton}
          onClick={onOpenOrder}
        >
          <div className={styles.topRow}>
            <div className={styles.orderId}>#{order.id}</div>
            <div className={styles.price}>{Number(order.price).toFixed(0)} ₽</div>
          </div>

          <div className={styles.receiver}>{order.receiver || "Без имени"}</div>

          <div className={styles.bottomRow}>
            <span className={styles.badge}>{date}</span>
            <span className={styles.badgeMuted}>
              {deliveryTypes[order.wayDelivery] || "Доставка"}
            </span>
          </div>
        </button>
      </article>
}

